/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, Input } from '@angular/core';

// Models
import { App } from '@models';
import { EntitlementService } from '@windriver/ui';
import { AuthService, AuthSettingValue } from '@windriver/authentication';

@Component({
  selector: 'wsn-app-item',
  templateUrl: './app-item.component.html',
  styleUrls: ['./app-item.component.scss']
})
export class AppItemComponent {
  @Input() item: App;
  @Input() openInNewTab: AuthSettingValue;

  constructor(private authService: AuthService, private entitlementService: EntitlementService) {}

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  openLink(url: string) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions, eqeqeq
    this.openInNewTab == AuthSettingValue.openInNewTab
      ? this.openLinkInNewTab(url.replace('registry', 'system.registry'))
      : this.openLinkInCurrentTab(url);
  }

  openLinkInCurrentTab(url: string) {
    window.location.href = url.replace('registry', 'system.registry');
  }

  openLinkInNewTab(url: string) {
    window.open(url.replace('registry', 'system.registry'), '_blank');
  }

  async updateFavoriteApp(id: string, isFavorite: boolean) {
    const favorite = isFavorite ? this.authService.removeFavoriteApp : this.authService.favoriteApp;
    await favorite(id).toPromise();
    this.entitlementService.entitlementsRefreshSubject.next();
  }
}
